<template>
  <layout title="Face authentication trends & knowledge Blog">
    <JsonLd :entries="jsonLdEntries" />
    <div
      class="relative px-8 pt-8 pb-20 mx-auto xl:px-5 max-w-7xl sm:px-6 lg:pt-10 lg:pb-28"
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 sm:text-4xl sm:leading-10"
          >
            Blog
          </h1>
          <p class="mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
            The lastest insights on the future of authentication.
          </p>
        </div>

        <SearchBar
          :errorsExists="errorsExists"
          :type="type"
          :input="searchData.search"
          @getData="getBlog"
        />

        <div class="mt-6 gap-5" v-if="showLoading">
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between"
            :count="3"
          />
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between mt-4"
            :count="3"
          />
        </div>
        <div v-else>
          <div
            class="grid gap-5 mx-auto mt-6 sm:grid-cols-2 lg:grid-cols-3"
            v-if="posts"
            id="elementToScroll"
          >
            <article
              :id="'post-' + post.id"
              class="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white"
              typeof="Article"
              v-for="(post, index) in posts.data"
              :key="index"
            >
              <inertia-link :href="'blog/' + post.slug" class="h-full">
                <meta property="name" :content="post.title" />
                <meta property="author" typeof="Person" content="admin" />
                <meta
                  property="dateModified"
                  :content="post.updated_at | formatDate"
                />
                <meta
                  class="uk-margin-remove-adjacent"
                  property="datePublished"
                  :content="post.created_at | formatDate"
                />
                <div class="flex flex-col justify-between h-full">
                  <div>
                    <div class="shrink-0">
                      <img
                        class="object-cover w-full h-48"
                        :src="aws_image_path + post.image"
                        alt=""
                      />
                    </div>
                    <div
                      class="relative flex flex-col justify-between flex-1 p-6"
                    >
                      <div class="flex-1">
                        <h3
                          class="mt-2 text-xl font-semibold leading-7 text-gray-900"
                        >
                          {{ post.title }}
                        </h3>
                        <p class="mt-3 text-base leading-6 text-gray-500">
                          {{
                            post.body.length > 200
                              ? removeHTMLtags(post.body).substring(0, 200) +
                                "..."
                              : removeHTMLtags(post.body)
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="flex items-center p-4 bg-gray-50">
                      <div>
                        <p class="text-sm font-medium leading-5 text-gray-900">
                          Written on
                          <time :datetime="post.created_at | formatDate">{{
                            post.created_at | formatDate
                          }}</time>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </inertia-link>
            </article>
          </div>
        </div>
        <pagination
          class="mt-10"
          :data="posts"
          @changePage="changePage"
          elementToScroll="elementToScroll"
        />
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const pagination = () =>
  import(
    /* webpackChunkName: "pagination" */ "../Components/Layout/pagination.vue"
  );

import SearchBar from "../Components/Layout/Resources/SearchBar.vue";
import JsonLd from "../Components/SEO/JsonLd.vue";
import { buildCollectionPageSchema } from "../utils/structuredData";

export default {
  props: {
    errors: Object,
  },
  components: { layout, pagination, SearchBar, JsonLd },
  data() {
    return {
      posts: null,
      aws_image_path: process.env.MIX_IMAGES_PATH,
      errorsExists: false,
      type: "blog",
      searchData: {
        order: null,
        category: null,
        search: null,
      },
      tagByURL: null,
      showLoading: true,
    };
  },
  created() {
    this.getTagByURL();
    this.changePage(1);
  },
  computed: {
    jsonLdEntries() {
      return [
        buildCollectionPageSchema({
          title: "Blog",
          items: (this.posts?.data || []).map((post) => ({
            name: post.title,
            url: `/resources/blog/${post.slug}`,
          })),
        }),
      ];
    },
  },

  methods: {
    getTagByURL() {
      const params = new URLSearchParams(location.search);

      if (params.get("search")) {
        this.searchData.search = decodeURIComponent(params.get("search"));
      }
    },
    removeHTMLtags(text) {
      return text.replace(/(<([^>]+)>)/gi, "");
    },

    changePage(page) {
      this.showLoading = true;
      this.getBlog(
        page,
        this.searchData.order,
        this.searchData.category,
        this.searchData.search
      );
    },

    getBlog(page, order, category, search) {
      this.searchData.order = order;
      this.searchData.category = category;
      this.searchData.search = search;

      this.axios
        .get(
          `/resources-by-filter?page=${page}&type=${this.type}&order=${order}&category=${category}&search=${search}`
        )
        .then((response) => {
          this.posts = response.data;
          this.showLoading = false;

          if (this.posts.data.length > 0) {
            this.errorsExists = false;
          } else {
            this.errorsExists = true;
          }
        });
    },
  },
};
</script>
